import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function queryPracticeGroupMembers(): Promise<
  PracticeGroupOrchidProMember[]
> {
  const res = await fetchOrchidAPI("/api/users/v1/practice_group/members");
  if (!res.ok) {
    throw new Error(
      `failed to fetch members of practice group: ${getErrorDetail(
        await res.text(),
      )}`,
    );
  }
  return res.json();
}
